const allCount = `query MyQuery {
  managementStats {
    order {
      salesDivision {
        id
        name
        count
      }
      sourcingRequest {
        id
        name
        count
      }
      productQuote {
        id
        name
        count
      }
      nonActive {
        id
        name
        count
      }
      totalSalesDivision
      totalSourcingRequest
      totalProductQuote
      totalNonActive
      allCount
      byStatuses {
        count
        id
        name
      }
      divAftersalesCount
      divLogisticCount
      divPurchaseCount
      divSalesCount
      divWarehouseCount
    }
    product {
      allCount
    }
    user {
      allCount
      byRoles {
        count
        id
        name
      }
    }
  }
}`

export { allCount }